import { Fragment } from 'react';
import { useLocation } from 'react-router-dom';

import classes from './Layout.module.css';
import MainNavigation from './MainNavigation';
import InvelpsGlobalNav from '../../../../components/InvelpsGlobalNav';

const Layout = (props) => {
  const location = useLocation();
  const path = location.pathname || '/';
  // Ne pas afficher MainNavigation sur les routes Landing (/) et MarketFlow (/marketflow) car elles ont leur propre Header
  const showMainNavigation =
    path !== '/' &&
    path !== '/marketflow' &&
    !path.startsWith('/marketflow/ticker') &&
    !path.startsWith('/capital');

  const showInvelpsGlobalNav =
    path === '/' ||
    path === '/marketflow' ||
    path.startsWith('/marketflow/ticker');

  return (
    <Fragment>
      {showInvelpsGlobalNav && <InvelpsGlobalNav showMarketSubNav />}
      {showMainNavigation && <MainNavigation />}
      <main className={classes.main}>{props.children}</main>
    </Fragment>
  );
};

export default Layout;